import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = 'consensusmaker_device_id';
const SESSION_ID_KEY = 'consensusmaker_session_id';
const VOTED_POLLS_KEY = 'consensusmaker_voted_polls';

interface VotedPoll {
  pollId: string;
  pollName: string;
  timestamp: number;
}

export function getDeviceId(): string {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
}

export function getSessionId(): string {
  let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
  if (!sessionId) {
    sessionId = uuidv4();
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }
  return sessionId;
}

export function getAnonymousId(): string {
  return getDeviceId();
}

export function hasVotedInPoll(pollId: string): boolean {
  const votedPolls: VotedPoll[] = JSON.parse(localStorage.getItem(VOTED_POLLS_KEY) || '[]');
  return votedPolls.some(poll => poll.pollId === pollId);
}

export function markPollAsVoted(pollId: string, pollName: string): void {
  const votedPolls: VotedPoll[] = JSON.parse(localStorage.getItem(VOTED_POLLS_KEY) || '[]');
  if (!votedPolls.some(poll => poll.pollId === pollId)) {
    votedPolls.push({
      pollId,
      pollName,
      timestamp: Date.now()
    });
    localStorage.setItem(VOTED_POLLS_KEY, JSON.stringify(votedPolls));
  }
}

export function getVotedPolls(): VotedPoll[] {
  return JSON.parse(localStorage.getItem(VOTED_POLLS_KEY) || '[]');
}

const CREATED_POLLS_KEY = 'consensusmaker_created_polls';

interface CreatedPoll {
  pollId: string;
  pollName: string;
  timestamp: number;
}

export function markPollAsCreated(pollId: string, pollName: string): void {
  const createdPolls: CreatedPoll[] = JSON.parse(localStorage.getItem(CREATED_POLLS_KEY) || '[]');
  if (!createdPolls.some(poll => poll.pollId === pollId)) {
    createdPolls.push({
      pollId,
      pollName,
      timestamp: Date.now()
    });
    localStorage.setItem(CREATED_POLLS_KEY, JSON.stringify(createdPolls));
  }
}

export function getCreatedPolls(): CreatedPoll[] {
  return JSON.parse(localStorage.getItem(CREATED_POLLS_KEY) || '[]');
}